import * as React from 'react'

import { Box, Chevron, Colors, Popover, useToggle } from '@factorialco/deprecated-design-system'
import { TimesheetEstimatedTimeFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type Store from 'modules/attendance/components/ClockIn/Store'
import TooltipHeader from 'modules/attendance/components/ClockIn/Tooltip/Header'
import TooltipRow from 'modules/attendance/components/ClockIn/Tooltip/Row'
import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  store: Store
  date: moment.Moment
  grayedOutColor: Colors
  estimatedTime: TimesheetEstimatedTimeFragment
}

export const EstimatedHours = ({ estimatedTime, store, date, grayedOutColor }: Props) => {
  const [open, toggle] = useToggle(false)
  const { minutes, regularMinutes, overtimeMinutes } = estimatedTime

  useEffect(() => {
    if (open) {
      track(trackingEvents.timeTracking.seeEstimatedHoursTooltip, {
        user_checking_own_timesheet: store.isSeeingOwnPeriod(),
        date: dateToString(date, 'backend'),
      })
    }
  }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Popover.ItemList attachment="bottom center" toggle={toggle} open={open} gapDivider={false}>
      <Box inline flexDirection="row" gap="s4" alignItems="center">
        <MinutesToText value={minutes} weight="medium" alwaysRemainder color={grayedOutColor} />
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </Box>
      <TooltipHeader
        title={i18n.t('clock_in.planned_hours')}
        minutes={regularMinutes + overtimeMinutes}
      />
      <TooltipRow label={i18n.t('clock_in.regular_hours')} value={regularMinutes} />
      <TooltipRow label={i18n.t('clock_in.schedule_overtime')} value={overtimeMinutes} />
    </Popover.ItemList>
  )
}
